import React, { useState } from 'react';
import { Modal } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useI18n } from '@/hooks/useI18n';

interface ReviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAccept: (note: string) => Promise<void> | void;
    onReject: (note: string) => Promise<void> | void;
}

export const ReviewModal: React.FC<ReviewModalProps> = ({
    isOpen,
    onClose,
    onAccept,
    onReject,
}) => {
    const { t } = useI18n();
    const [reviewNote, setReviewNote] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleAccept = async () => {
        setIsSubmitting(true);
        try {
            await onAccept(reviewNote);
            setReviewNote('');
            onClose();
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReject = async () => {
        setIsSubmitting(true);
        try {
            await onReject(reviewNote);
            setReviewNote('');
            onClose();
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setReviewNote('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title={t('itinerary.completeReview')}>
            <div className="space-y-3 p-4">
                <p className="text-gray-600">
                    {t('itinerary.reviewDescription')}
                </p>

                <Textarea
                    placeholder={t('itinerary.addOptionalNote')}
                    value={reviewNote}
                    onChange={(e) => setReviewNote(e.target.value)}
                    className="min-h-[80px]"
                />

                <div className="flex gap-3 justify-end pt-4">
                    <Button
                        onClick={handleReject}
                        variant="outline"
                        size="sm"
                        disabled={isSubmitting}
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={handleAccept}
                        size="sm"
                        disabled={isSubmitting}
                    >
                        Accept
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
